
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

import { createApp } from 'vue';
import Vueform from '@vueform/vueform'
import vueformConfig from './../../vueform.config.js'

const app = createApp()
app.use(Vueform, vueformConfig)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * This event was manually added to wire-extender.js
 * Beware when updating this file to reinclude the event dispatch
 */
document.addEventListener('loadVueForm', async function() {
    if (document.getElementById("wire-app")) {
        app.mount('#wire-app')
    }
});

app.use(require('vue-cookies'));
